module.exports = __webpack_public_path__ + "img/banner.6b2e5caa.png";